<template>
  <fieldset>
    <div class="text-primary text-md bold uppercase mb-2" data-testid="eventdates-option-title">{{ title }}</div>
    <div class="-space-y-px">
      <RadioGroup v-model="selected" :radio-values="localEventdates" data-testid="eventdate" required></RadioGroup>
    </div>
  </fieldset>
</template>

<script lang="ts" setup>
import RadioGroup from "../../ui/RadioGroup.vue"
import { EventdateInterface } from "@/js/interfaces/eventdate"
import { computed } from "vue"

const props = defineProps<{
  modelValue?: number | null | undefined | "custom",
  eventdates: EventdateInterface[]
}>()

const emit = defineEmits(["update:modelValue"])

const title = computed(() => {
  return props.eventdates[0].option_title
})

const localEventdates = computed(() => {
  const nextYear = new Date().getFullYear() + 1
  const regex = new RegExp(`(${nextYear})`, "g")
  return props.eventdates.map(eventdate => ({
    ...eventdate,
    title: eventdate.title.replace(regex, "<span class=\"highlight-underline\">$1</span>")
  }))
})

const selected = computed({
  get: () => {
    return props.modelValue ? props.modelValue : null
  },
  set: (value) => {
    emit("update:modelValue", value)
  }
})
</script>
<style>
.highlight-underline {
  text-decoration: underline;
}
</style>
